import { forwardRef, ReactNode, Ref } from 'react';

import clsx from 'clsx';

import { Divider, Label, listSeparatorClasses, Root } from './styles';

export interface Props {
  /** @default 'primary' */
  color?: 'primary' | 'success' | 'warning' | 'error';
  leftLabel?: ReactNode;
  leftAriaLabel?: string;
  rightLabel?: ReactNode;
  rightAriaLabel?: string;
  className?: string;
}

const ListSeparator = (
  { color = 'primary', leftLabel, leftAriaLabel, rightLabel, rightAriaLabel, className }: Props,
  ref: Ref<HTMLDivElement>
) => {
  return (
    <Root
      ref={ref}
      className={clsx(
        {
          [listSeparatorClasses.colorPrimary]: color === 'primary',
          [listSeparatorClasses.colorSuccess]: color === 'success',
          [listSeparatorClasses.colorWarning]: color === 'warning',
          [listSeparatorClasses.colorError]: color === 'error',
        },
        className
      )}
    >
      <Divider className={listSeparatorClasses.edgeDivider} />
      {leftLabel && (
        <Label role="status" aria-label={leftAriaLabel}>
          {leftLabel}
        </Label>
      )}
      <Divider />
      {rightLabel && (
        <Label role="status" aria-label={rightAriaLabel}>
          {rightLabel}
        </Label>
      )}
      <Divider className={listSeparatorClasses.edgeDivider} />
    </Root>
  );
};

export default forwardRef(ListSeparator);
